<template>
  <div class="dropdownContainer relative" :class="id" v-click-outside="closeDropdown">
    <label v-if="label" class="mb-2 label-L text-[#1F1D1F]">{{ label }}</label>
    <div
      class="h-[42px] py-2 px-2 cursor-pointer bg-white border border-[#B7B2B5] rounded-[6px] relative"
      @click="toggleDropdown"
    >
      <span v-if="placeholder && !selectedOption" class="label-L text-[#1F1D1F]">{{
        placeholder
      }}</span>
      <span v-else class="label-L">{{ selectedOption }}</span>
      <!-- Clear Icon (X) -->
      <div
        v-if="selectedOption"
        class="clear-icon absolute end-12 top-1/2 -translate-y-1/2"
        @click.stop="clearSelection"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M15 5L5 15M5 5L15 15"
            stroke="#555055"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
      <!-- Caret Down Icon -->
      <div
        class="caret-down absolute end-4 top-1/2 -translate-y-1/2 duration-200"
        :class="dropdownIsOpened ? 'rotate-180' : ''"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.0885 8.0495C18.5145 8.47553 18.5145 9.16625 18.0885 9.59228L12.2703 15.4105C11.8443 15.8365 11.1536 15.8365 10.7275 15.4105L4.90936 9.59228C4.48334 9.16625 4.48334 8.47553 4.90936 8.0495C5.33539 7.62347 6.02612 7.62347 6.45214 8.0495L11.4989 13.0963L16.5457 8.0495C16.9718 7.62347 17.6625 7.62347 18.0885 8.0495Z"
            fill="#555055"
          />
        </svg>
      </div>
    </div>
    <!-- Dropdown Options -->
    <div
      class="dropdown bg-white rounded-[6px] overflow-hidden"
      :class="dropdownIsOpened ? 'block' : 'hidden'"
    >
      <ul>
        <li
          v-for="option of options"
          :key="option"
          class="hover:bg-primary-light hover:text-primary cursor-pointer p-3"
          @click="handleOnSelect(option)"
        >
          {{ option }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectBox",

  props: {
    id: {
      required: true,
      default: null,
    },
    label: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "โปรดเลือก",
    },
    options: {
      type: Array,
      required: true,
    },
    modelValue: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      dropdownIsOpened: false,
      selectedOption: this.modelValue || "",
    };
  },

  watch: {
    modelValue(newValue) {
      this.selectedOption = newValue;
    },
  },

  methods: {
    toggleDropdown() {
      this.dropdownIsOpened = !this.dropdownIsOpened;
    },

    closeDropdown() {
      if (this.dropdownIsOpened) {
        this.dropdownIsOpened = false;
      }
    },

    handleOnSelect(option) {
      this.selectedOption = option;
      this.dropdownIsOpened = false;
      // Emit events
      this.$emit("select", option);
      this.$emit("update:modelValue", option);
      // Log the selected option
      console.log("เลือก:", option);
    },

    clearSelection() {
      this.selectedOption = "";
      this.dropdownIsOpened = false;

      // Emit events with empty value
      this.$emit("select", "");
      this.$emit("update:modelValue", "");

      // Log the cleared selection
      console.log("ล้างการเลือก");
    },
  },
};
</script>

<style scoped>
.dropdown {
  position: absolute;
  width: 100%;
  margin-top: 5px;
  z-index: 100;
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.25);
}

.clear-icon {
  cursor: pointer;
}
</style>
